<template>
    <div class="index">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <!-- 第 1 行 新闻中心 企业资讯 @error="imgError"     -->
            <div class="line1">
                <div class="left">
                    <el-skeleton-item variant="image" class="skeleton" v-if=" checkImg == undefined || checkImg == ''"/>
                    <img :src="checkImg" alt="" class="swiperImg" @error="imgError" v-else>
                    <div class="swiper">
                        <div class="checkTitle">{{ checkTitle }}</div>
                        <ul>
                            <li v-for="(item, index) in newsList.length" :key="index" :class="newActive==index ? 'dotActive' : ''"></li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="news">
                        <div class="top">
                            <div class="top_left">
                                <span class="new" :class="newtab==1 ? 'active' : ''" @click="newtabClick(1)">
                                <!-- <img src="../assets/img/index/new.png" alt=""> -->
                                    新闻中心
                                </span>
                                <div class="interval"></div>
                                <span class="message" :class="newtab==2 ? 'active' : ''" @click="newtabClick(2)">企业资讯</span>
                                <div class="interval"></div>
                                <span class="message" :class="newtab==3 ? 'active' : ''" @click="newtabClick(3)">机构动态</span>
                            </div>
                            <div class="more" @click="toPublicList(newtab)">更多</div>
                        </div>
                    </div>
                    <div class="list" v-if="newtab==1">
                        <ul>
                            <li v-for="(item, index) in newsList" :key="index">
                                <div style="display: flex;justify-content: left;align-items: center;width: 80%;" :class="newActive==index ? 'active' : ''" @mouseenter="newsMouseTo(item, index)" @click="toDetail(item, '新闻详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div style="color: #999;width: 20%;text-align: right;white-space: nowrap;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="list" v-if="newtab==2">
                        <ul>
                            <li v-for="(item, index) in intervalList" :key="index">
                                <div style="display: flex;justify-content: left;align-items: center;width: 90%;" @click="toDetail(item, '企业资讯详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div style="color: #999;width: 20%;text-align: right;white-space: nowrap;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="list" v-if="newtab==3">
                        <ul>
                            <li v-for="(item, index) in dynamicList" :key="index">
                                <div style="display: flex;justify-content: left;align-items: center;width: 90%;" @click="toDetail(item, '机构动态详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div style="color: #999;width: 20%;text-align: right;white-space: nowrap;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 第 2 行 活动通知 政策法规 信用专家-->
            <div class="line">
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">活动通知</div>
                        <div class="more" @click="toPublicList2('活动通知')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in activityList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '活动通知详情')">
                                    <!-- <span class="point"></span> -->
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">政策法规</div>
                        <div class="more" @click="toPublicList2('政策法规')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in policyList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '政策法规详情')">
                                    <!-- <span class="point"></span> -->
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- expert -->
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用专家</div>
                        <div class="more" @click="toPersonSearch('信用专家')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in expertList" :key="index" style="">
                                <div class="left" style="display: flex;align-items: center;flex: 0 0 30%;white-space: nowrap;" @click="toPersonDetail(item, '信用专家详情')">
                                    <!-- <span class="point"></span> -->
                                    <span class="title">{{ item.name }}</span>
                                </div>
                                <div class="right" style="color: #999;white-space: nowrap;flex: 1;overflow: hidden;text-overflow: ellipsis;text-align: left;margin-right: 10px;">{{ item.workUnit }}</div>
                                <div class="right" style="color: #999;flex: 0 0 auto;text-align: right;white-space: nowrap;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                        <!-- <ul>
                            <li v-for="(item, index) in expertList" :key="index" @click="toPersonDetail(item, '信用专家详情')">
                                <img :src="baseUrl + item.peopleImg" alt="" @error="personImgError">
                                <div style="margin-left: 15px;white-space: nowrap;">
                                    <div class="title">{{ item.name }}</div>
                                    <div class="profession">{{ item.duties }}</div>
                                </div>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <!-- 第 3 行 广告1-->
            <!-- <div class="line">
                <div class="advertising four" >
                    
                </div>
            </div> -->
            <!-- 第 3 行 信用研究 信用管理 信用案例-->
            <div class="line line3">
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用研究</div>
                        <div class="more" @click="toPublicList2('信用研究')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in studyList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '信用研究详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用管理</div>
                        <div class="more" @click="toPublicList2('信用管理')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in managementList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '信用管理详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用案例</div>
                        <div class="more" @click="toPublicList2('信用案例')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in caseList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '信用案例详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 第 4 行 系统入口(待替换新图片)-->
            <div class="line">
                <div class="advertising2">
                    <img v-for="(item, index) in advertisingList3" :key="index" :src="item.img" alt="" @click="toJump(item)" :style="item.href ? 'cursor: pointer' : ''">
                </div>
            </div>
            <!-- 第 5 行 诚信标杆企业 星级诚信企业 诚信企业家-->
            <div class="line">
                <!-- <div class="chunk2 CXT">
                    <div class="publicTop">
                        <div class="title">企业诚信官</div>
                        <div class="more" @click="toIntegrity('企业诚信官')">更多</div>
                    </div>
                    <div class="content">
                        <ul class="list">
                            <li v-for="(item, index) in CXTList2" :key="index" @click="toGoodStudents('优秀学员', 0)">
                                <img :src="baseUrl + item.peopleImg" style="width: 74px;height: 52px;object-fit: contain;background-color: #F6F8FB;" alt="" @error="CXTImgError">
                                <div style="margin-left: 15px;">
                                    <div class="title">{{ item.duties }} {{ item.name }}</div>
                                    <div class="profession">{{ item.workUnit }} </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <!-- sightcing -->
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">诚信倡议单位</div>
                        <div class="more" @click="toInitiativeMore">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in sightcingList" :key="index" @click="toInitiativeDetail(item)">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title || item.name }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- starLevel -->
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">星级诚信企业</div>
                        <div class="more" @click="toStarLevelMore('星级诚信企业')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in starLevelList" :key="index" @click="toStarLevel(item, '星级诚信企业详情')">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;">
                                    <span class="point"></span>
                                    <span class="title">{{ item.name }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                        <!-- <ul>
                            <li v-for="(item, index) in starLevelList" :key="index" @click="toStarLevel(item, '星级诚信企业详情')">
                                <img :src="baseUrl + item.billboard" alt="" @error="imgerrorfun">
                                <span class="title">{{ item.name }}</span>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用企业</div>
                        <div class="more" @click="toEvaluateCompanyMore('信用企业')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in evaluateCompanyList" :key="index" @click="toEvaluateCompany('信用企业详情', item)">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;">
                                    <span class="point"></span>
                                    <span class="title">{{ item.name }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.grade">{{ item.grade }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 第 6 行 广告2-->
            <!-- <div class="line">
                <div class="advertising" v-for="(item, index) in advertisingList2" :key="index">
                    <img :src="item.img" alt="" @click="toJump(item)">
                </div>
            </div> -->
            <!-- 第 6 行 信用报告 信用指数 信用标准-->
            <div class="line">
                <!-- <div class="chunk ">
                    <div class="publicTop">
                        <div class="title">信用企业</div>
                        <div class="more" @click="toEvaluateCompanyMore('信用企业')">更多</div>
                    </div>
                </div> -->
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用报告</div>
                        <div class="more" @click="toPublicList2('信用报告')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in topHundredList" :key="index" @click="toDetail(item, '信用报告详情')">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title || item.name }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用指数</div>
                        <div class="more" @click="toPublicList2('信用指数')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in exponentList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '信用指数详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="chunk common">
                    <div class="publicTop">
                        <div class="title">信用标准</div>
                        <div class="more" @click="toPublicList2('信用标准')">更多</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in standardList" :key="index">
                                <div class="left" style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '信用标准详情')">
                                    <span class="point"></span>
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div class="right" style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        <!-- 新图片链接 -->
        <div class="line">
            <div class="advertising2">
                <img :src="require('../assets/img/index/企业诚信官.png')" alt="企业诚信官">
                <img :src="require('../assets/img/index/企业合规官.png')" alt="企业合规官" @click="toCCO" style="cursor: pointer">
                <img :src="require('../assets/img/index/企业合规管培养基地.png')" alt="企业合规官培养基地">
            </div>
        </div>
        </div>

        
        <!-- 第 10 行 友情链接-->
        <div class="friendLink">
            <div class="content">
                <div class="from">
                    <div class="title">友情链接:</div>
                    <div ref="autocomplete" style="display: flex;justify-content: space-between;width: 100%;margin-left: 15px;">
                        <div class="selet" @click="seletClick(1)">
                            <span>社会信用体系建设部际联席会议成员单位</span>
                            <span class="el-icon-caret-top icon" v-if="seletShow == 1"></span>
                            <span class="el-icon-caret-bottom icon" v-else></span>
                        </div>
                        <div class="selet" @click="seletClick(2)">
                            <span>全国性社会团体</span>
                            <span class="el-icon-caret-top icon" v-if="seletShow == 2"></span>
                            <span class="el-icon-caret-bottom icon" v-else></span>
                        </div>
                        <div class="selet" @click="seletClick(3)">
                            <span>地方性信用协会</span>
                            <span class="el-icon-caret-top icon" v-if="seletShow == 3"></span>
                            <span class="el-icon-caret-bottom icon" v-else></span>
                        </div>
                        <div class="selet" @click="seletClick(4)">
                            <span>信用服务机构</span>
                            <span class="el-icon-caret-top icon" v-if="seletShow == 4"></span>
                            <span class="el-icon-caret-bottom icon" v-else></span>
                        </div>
                    </div>

                    <!-- 社会信用体系建设部际联席会议成员单位 -->
                    <div class="pop" ref="pop" v-if="seletShow == 1">
                        <el-descriptions :column="friendLinkColumn">
                            <el-descriptions-item v-for="item in friendLinkList" :key="item.id"><span @click="toUrl(item)">{{ item.name }}</span></el-descriptions-item>
                        </el-descriptions>
                        <el-empty description="暂无数据" v-if="friendLinkList.length == 0"></el-empty>
                    </div>
                    <!-- 全国性社会团体 -->
                    <div class="pop" ref="pop" v-if="seletShow == 2">
                        <el-descriptions :column="friendLinkColumn">
                            <el-descriptions-item v-for="item in friendLinkList2" :key="item.id"><span @click="toUrl(item)">{{ item.name }}</span></el-descriptions-item>
                        </el-descriptions>
                        <el-empty description="暂无数据" v-if="friendLinkList2.length == 0"></el-empty>
                    </div>
                    <!-- 地方性信用协会 -->
                    <div class="pop" ref="pop" v-if="seletShow == 3">
                        <el-descriptions :column="friendLinkColumn">
                            <el-descriptions-item v-for="item in friendLinkList3" :key="item.id"><span @click="toUrl(item)">{{ item.name }}</span></el-descriptions-item>
                        </el-descriptions>
                        <el-empty description="暂无数据" v-if="friendLinkList3.length == 0"></el-empty>
                    </div>
                    <!-- 信用服务机构 -->
                    <div class="pop" ref="pop" v-if="seletShow == 4">
                        <el-descriptions :column="friendLinkColumn">
                            <el-descriptions-item v-for="item in friendLinkList4" :key="item.id"><span @click="toUrl(item)">{{ item.name }}</span></el-descriptions-item>
                        </el-descriptions>
                        <el-empty description="暂无数据" v-if="friendLinkList4.length == 0"></el-empty>
                    </div>
                </div>
                <!-- <img src="../assets/img/index/friendLink.png" alt=""> -->
                <!-- <div class="list">
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList1" :key="item.id">{{ item.name }}</div>
                    </div>
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList2" :key="item.id">{{ item.name }}</div>
                    </div>
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList3" :key="item.id">{{ item.name }}</div>
                    </div>
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList4" :key="item.id">{{ item.name }}</div>
                    </div>
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList5" :key="item.id">{{ item.name }}</div>
                    </div>
                    <div class="item">
                        <div class="val" v-for="item in friendLinkList6" :key="item.id">{{ item.name }}</div>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 分享数字人 -->
        <div class="digitalHuman" :style="digitalHumanStyle">
            <div class="digitalHumanHandle" title="拖动位置" @mousedown="startDigitalHumanDrag"></div>
            <iframe
                class="digitalHumanFrame"
                :class="{ dragging: digitalHumanDragging }"
                src="https://workbrain.cn/room/#/sharePeople?applyId=17131685437990001&language=zh_CN"
                frameborder="0"
            ></iframe>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../api/api'
import { decrypt } from '../utils/decode'
import publicHeaders from '../components/header.vue'
import foot from '../components/foot.vue'
import {baseURL} from '../api/network.js';
export default {
    name: 'index',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            checkImg: '',
            checkTitle: '',
            newtab: 1,
            baseUrl: baseURL,
            indexInfo: {},
            newsList: [ //新闻列表
                // {
                //     title: '《全国诚信经营示范企业要求》和《全国优秀',
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_1.png'),
                // },
                // {
                //     title: '中国人民银行：下半年全面强化征信监管',
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_2.png'),
                // },
                // {
                //     title: '《企业诚信管理体系要求》国家标准发布实施广东省佛山的',
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_3.png'),
                // },
                // {
                //     title: '全国市场监管系统信用监管工作座谈会在福州阿达萨达萨达萨达飒飒',
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_4.png'),
                // },
                // {
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_5.png'),
                // },
            ],
            intervalList: [ //企业资讯
                // {
                //     title: '诺夫i懊悔vui哦VS你补发i',
                //     time: '2023-08-21',
                //     imgUrl: require('../assets/img/index/line1_1.png'),
                // },
                // ...
            ],
            dynamicList: [ //机构动态
            ],
            newActive: 0,
            intervalActive: 0,
            activityList: [ //活动通知列表
                // {
                //     title: '关于开展2023年"诚信兴诚信兴诚信兴诚信兴诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
            ],
            caseList: [], //信用案例列表
            standardList: [], //信用标准列表
            studyList: [], //信用研究列表
            managementList: [], //信用管理列表
            exponentList: [], //信用指数列表
            policyList: [ //政策法规列表
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '守信践诺守信践诺守信践诺守信践诺守信践诺守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
            ],
            evaluateList: [ //信用评价列表
                {
                    name: '企业信用评价活动通知',
                },
                {
                    name: '企业信用评价管理办法',
                },
                {
                    name: '企业信用评价工作流程',
                },
                {
                    name: '企业信用评价证书标牌',
                },
                {
                    name: '企业信用评价申请材料',
                },
            ],
            evaluateCompanyList: [ //信用企业列表
                // {
                //     title: '江西省善德建筑工程有限公司',
                //     rank: 'A'
                // },
                // {
                //     title: '中铁物资集团有限公司',
                //     rank: 'A'
                // },
                // {
                //     title: '上海开顺投资管理有限公司 ',
                //     rank: 'AAA'
                // },
                // {
                //     title: '赤峰卫民大药房医药有限公司',
                //     rank: 'AA'
                // },
                // {
                //     title: '赤峰合生阳光热力有限公司',
                //     rank: 'A'
                // },
            ],
            companyInput: '',
            advertisingList: [ //广告列表
                {
                    img: require('../assets/img/index/advertising1.png'),
                    href: '',
                    title: '',
                    type: 'out'
                },
                {
                    img: require('../assets/img/index/advertising2.png'),
                    href: '',
                    title: '',
                    type: 'out'
                },
            ],
            advertisingList2: [
                {
                    img: require('../assets/img/index/advertising12.jpg'),
                    href: '',
                    title: '',
                    type: 'out'
                },
                {
                    img: require('../assets/img/index/advertising10.png'),
                    href: 'https://www.topo360.com/#/',
                    title: '',
                    type: 'out'
                },
            ],
            topHundredList: [
            ],
            starLevelList: [ //星级诚信企业
                // {
                //     title: '北京长友物业管理有限公司北京长友物业管理有限公司北京长友物业管理有限公司',
                //     imgUrl: require('../assets/img/index/starLevel.png'),
                // },
                // {
                //     title: '北京紫金百合投资有限公司',
                //     imgUrl: require('../assets/img/index/starLevel.png'),
                // },
                // {
                //     title: '北京华升融智商务咨询有限公司',
                //     imgUrl: require('../assets/img/index/starLevel.png'),
                // },
                // {
                //     title: '国民淀粉化学贸易有限公司',
                //     imgUrl: require('../assets/img/index/starLevel.png'),
                // },
            ],
            sightcingList: [ //诚信标杆企业
                // {
                //     title: '北京鼎汉科技股份有限公司',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '北京鼎汉科技股份有限公司',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '北京鼎汉科技股份有限公司北京鼎汉科技股份有限公司北京鼎汉科技股份有限公司',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '北京鼎汉科技股份有限公司',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '北京鼎汉科技股份有限公司',
                //     time: '2023-08-21'
                // },
            ],
            expertList: [ //信用专家
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../assets/img/index/expert.png'),
                //     profession: '专家'
                // },
            ],
            CXTList: [ //企业诚信官课题列表
                // {
                //     name: '课题一'
                // },
                // {
                //     name: '课题二'
                // },
                // {
                //     name: '课题三'
                // },
                // {
                //     name: '课题四'
                // },
            ],
            CXTList2: [ //企业诚信官课题列表2
                // {
                //     imgUrl: require('../assets/img/index/certificate2.png'),
                //     title: '项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称',
                //     inform: '关于培训通知'
                // },
                // {
                //     imgUrl: require('../assets/img/index/certificate2.png'),
                //     title: '项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称',
                //     inform: '关于培训通知'
                // },
                // {
                //     imgUrl: require('../assets/img/index/certificate2.png'),
                //     title: '项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称',
                //     inform: '培训通知'
                // },
            ],
            entrepreneurtList: [ //诚信企业家
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司'
                // },
            ],
            advertisingList3: [ //系统入口
                {
                    img: require('../assets/img/index/advertising10.png'),
                    href: 'https://www.topo360.com/#/?token=eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJ6aG9uZ3FpeWFuIn0.ZqtMLptDaKaxcKboNl_to2n8xsePgt_BllnbyiY8B80',
                    title: '企业信用信息查询系统',
                    type: 'in'
                },
                {
                    img: require('../assets/img/index/advertising12.jpg'),
                    href: 'https://www.souxin.org/index/cindex/code/NjkyLzU3NS81NzYvMA==?token=eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJ6aG9uZ3FpeWFuIn0.ZqtMLptDaKaxcKboNl_to2n8xsePgt_BllnbyiY8B80',
                    title: '企业信用合规测评系统',
                    type: 'in'
                },
                {
                    img: require('../assets/img/index/advertising1.png'),
                    href: '',
                    title: '企业信用评价系统',
                    type: 'out'
                },
            ],
            tree: [],
            swiperNew: '',
            friendLinkList: [
                // {
                //     name: '中共中央宣传部',
                //     url: 'http://www.wenming.cn',
                //     id: '01',
                // },
                // {
                //     name: '中共中央政法委员会',
                //     url: 'http://www.chinapeace.gov.cn',
                //     id: '02',
                // },
                // {
                //     name: '中央精神文明建设办公室',
                //     url: 'http://www.wenming.cn',
                //     id: '03',
                // },
                // {
                //     name: '中央网络安全和信息化委员会办公室',
                //     url: 'https://www.cac.gov.cn',
                //     id: '04',
                // },
                // {
                //     name: '中央机构编制委员会办公室',
                //     url: 'http://www.scopsr.gov.cn',
                //     id: '05',
                // },
                // {
                //     name: '国家发展和改革委员会',
                //     url: 'https://www.ndrc.gov.cn',
                //     id: '06',
                // },
                // {
                //     name: '教育部',
                //     url: 'https://www.moe.gov.cn',
                //     id: '07',
                // },
                // {
                //     name: '科学技术部',
                //     url: 'https://www.most.gov.cn',
                //     id: '08',
                // },
                // {
                //     name: '工业和信息化部',
                //     url: 'https://www.miit.gov.cn',
                //     id: '09',
                // },
                // {
                //     name: '公安部',
                //     url: 'https://www.mps.gov.cn',
                //     id: '10',
                // },
                // {
                //     name: '国家安全部',
                //     url: '',
                //     id: '11',
                // },
                // {
                //     name: '民政部',
                //     url: 'https://www.mca.gov.cn',
                //     id: '12',
                // },
                // {
                //     name: '司法部',
                //     url: 'https://www.moj.gov.cn',
                //     id: '13',
                // },
                // {
                //     name: '财政部',
                //     url: 'https://www.mof.gov.cn',
                //     id: '14',
                // },
                // {
                //     name: '人力资源和社会保障部',
                //     url: 'http://www.mohrss.gov.cn',
                //     id: '15',
                // },
                // {
                //     name: '生态环境部',
                //     url: 'https://www.mee.gov.cn',
                //     id: '16',
                // },
                // {
                //     name: '住房和城乡建设部',
                //     url: 'https://www.mohurd.gov.cn',
                //     id: '17',
                // },
                // {
                //     name: '交通运输部',
                //     url: 'https://www.mot.gov.cn',
                //     id: '18',
                // },
                // {
                //     name: '水利部',
                //     url: 'http://www.mwr.gov.cn',
                //     id: '19',
                // },
                // {
                //     name: '农业农村部',
                //     url: 'http://www.moa.gov.cn',
                //     id: '20',
                // },
                // {
                //     name: '商务部',
                //     url: 'https://www.mofcom.gov.cn',
                //     id: '21',
                // },
                // {
                //     name: '文化和旅游部',
                //     url: 'https://www.mct.gov.cn',
                //     id: '22',
                // },
                // {
                //     name: '国家卫生健康委员会',
                //     url: 'http://www.nhc.gov.cn',
                //     id: '23',
                // },
                // {
                //     name: '应急管理部',
                //     url: 'https://www.mem.gov.cn',
                //     id: '24',
                // },
                // {
                //     name: '中国人民银行',
                //     url: 'http://www.pbc.gov.cn',
                //     id: '25',
                // },
                // {
                //     name: '海关总署',
                //     url: 'http://www.customs.gov.cn',
                //     id: '26',
                // },
                // {
                //     name: '国家税务总局',
                //     url: 'https://www.chinatax.gov.cn',
                //     id: '27',
                // },
                // {
                //     name: '国家市场监督管理总局',
                //     url: 'https://www.samr.gov.cn',
                //     id: '28',
                // },
                // {
                //     name: '国家金融监督管理总局',
                //     url: 'https://www.cbirc.gov.cn',
                //     id: '29',
                // },
                // {
                //     name: '中国证券监督管理委员会',
                //     url: 'http://www.csrc.gov.cn',
                //     id: '30',
                // },
                // {
                //     name: '国家统计局',
                //     url: 'https://www.stats.gov.cn',
                //     id: '31',
                // },
                // {
                //     name: '国家知识产权局',
                //     url: 'https://www.cnipa.gov.cn',
                //     id: '32',
                // },
                // {
                //     name: '新华通讯社',
                //     url: 'https://www.news.cn',
                //     id: '33',
                // },
                // {
                //     name: '国家能源局',
                //     url: 'https://www.nea.gov.cn',
                //     id: '34',
                // },
                // {
                //     name: '国家铁路局',
                //     url: 'https://www.nra.gov.cn',
                //     id: '35',
                // },
                // {
                //     name: '中国民用航空局',
                //     url: 'https://www.caac.gov.cn',
                //     id: '36',
                // },
                // {
                //     name: '国家疾病预防控制局',
                //     url: 'https://www.ndcpa.gov.cn',
                //     id: '37',
                // },
                // {
                //     name: '国家外汇管理局',
                //     url: 'https://www.safe.gov.cn',
                //     id: '38',
                // },
                // {
                //     name: '国家药品监督管理局',
                //     url: 'https://www.nmpa.gov.cn',
                //     id: '39',
                // },
                // {
                //     name: '国家公务员局',
                //     url: 'http://www.scs.gov.cn',
                //     id: '40',
                // },
                // {
                //     name: '国家档案局',
                //     url: 'https://www.saac.gov.cn',
                //     id: '41',
                // },
                // {
                //     name: '最高人民法院',
                //     url: 'https://www.court.gov.cn',
                //     id: '42',
                // },
                // {
                //     name: '最高人民检察院',
                //     url: 'https://www.spp.gov.cn',
                //     id: '43',
                // },
                // {
                //     name: '中国共产主义青年团中央委员会',
                //     url: 'https://www.gqt.org.cn',
                //     id: '44',
                // },
                // {
                //     name: '中华全国工商业联合会',
                //     url: 'https://www.acfic.org.cn',
                //     id: '45',
                // },
                // {
                //     name: '中国国际贸易促进委员会',
                //     url: 'https://www.ccpit.org',
                //     id: '46',
                // },
                // {
                //     name: '中国残疾人联合会',
                //     url: 'https://www.cdpf.org.cn',
                //     id: '47',
                // },
                // {
                //     name: '中国国家铁路集团有限公司',
                //     url: 'http://www.china-railway.com.cn',
                //     id: '48',
                // },
            ],
            friendLinkList2: [
                // {
                //     name: '中国企业改革与发展研究会',
                //     url: 'https://www.cerds.cn',
                //     id: '49',
                // },
                // {
                //     name: '中国合作贸易企业协会',
                //     url: 'http://www.ccoop.org.cn',
                //     id: '50',
                // },
            ],
            friendLinkList3: [],
            friendLinkList4: [],
            seletShow: 0,
            digitalHumanPosition: {
                left: null,
                top: null
            },
            digitalHumanDragging: false,
            digitalHumanDragStart: {
                mouseX: 0,
                mouseY: 0,
                left: 0,
                top: 0
            },
        }
    },
    computed: {
        friendLinkColumn() {
            return window.innerWidth < 769 ? 2 : 5
        },
        digitalHumanStyle() {
            if (this.digitalHumanPosition.left === null || this.digitalHumanPosition.top === null) return {}
            return {
                left: this.digitalHumanPosition.left + 'px',
                top: this.digitalHumanPosition.top + 'px',
                right: 'auto',
                bottom: 'auto'
            }
        },
    },
    // 滚动监听事件
    mounted() {
      document.addEventListener('click', this.handleDocumentClick);
      this.initDigitalHumanPosition()
      window.addEventListener('resize', this.keepDigitalHumanInViewport)
    },
    // 销毁滚动监听事件
    destroyed () {
      document.removeEventListener('click', this.handleDocumentClick);
      window.removeEventListener('resize', this.keepDigitalHumanInViewport)
      document.removeEventListener('mousemove', this.onDigitalHumanDrag)
      document.removeEventListener('mouseup', this.stopDigitalHumanDrag)
    },
    created() {
        document.title = '企业信用建设服务平台'
        this.getIndexInfo()
        this.getQyzxList()
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.swiperNew)
        next();
    },
    methods: {
        getDigitalHumanSize() {
            const isCompact = window.innerWidth < 1700
            return {
                width: isCompact ? 72 : 92,
                height: isCompact ? 90 : 115
            }
        },
        initDigitalHumanPosition() {
            this.$nextTick(() => {
                const saved = window.localStorage.getItem('digitalHumanPosition')
                if (saved) {
                    try {
                        const parsed = JSON.parse(saved)
                        if (typeof parsed.left === 'number' && typeof parsed.top === 'number') {
                            this.digitalHumanPosition = parsed
                            this.keepDigitalHumanInViewport()
                            return
                        }
                    } catch (error) {}
                }

                const size = this.getDigitalHumanSize()
                this.digitalHumanPosition = {
                    left: Math.max(12, window.innerWidth - size.width - 24),
                    top: Math.max(12, window.innerHeight - size.height - 80)
                }
                this.keepDigitalHumanInViewport()
            })
        },
        keepDigitalHumanInViewport() {
            if (this.digitalHumanPosition.left === null || this.digitalHumanPosition.top === null) return
            const size = this.getDigitalHumanSize()
            const nextPosition = {
                left: Math.min(Math.max(12, this.digitalHumanPosition.left), Math.max(12, window.innerWidth - size.width - 12)),
                top: Math.min(Math.max(12, this.digitalHumanPosition.top), Math.max(12, window.innerHeight - size.height - 12))
            }
            this.digitalHumanPosition = nextPosition
            window.localStorage.setItem('digitalHumanPosition', JSON.stringify(nextPosition))
        },
        startDigitalHumanDrag(e) {
            e.preventDefault()
            const size = this.getDigitalHumanSize()
            const position = this.digitalHumanPosition.left === null
                ? { left: window.innerWidth - size.width - 24, top: window.innerHeight - size.height - 80 }
                : this.digitalHumanPosition
            this.digitalHumanDragging = true
            this.digitalHumanDragStart = {
                mouseX: e.clientX,
                mouseY: e.clientY,
                left: position.left,
                top: position.top
            }
            document.addEventListener('mousemove', this.onDigitalHumanDrag)
            document.addEventListener('mouseup', this.stopDigitalHumanDrag)
        },
        onDigitalHumanDrag(e) {
            if (!this.digitalHumanDragging) return
            const size = this.getDigitalHumanSize()
            this.digitalHumanPosition = {
                left: Math.min(Math.max(12, this.digitalHumanDragStart.left + e.clientX - this.digitalHumanDragStart.mouseX), Math.max(12, window.innerWidth - size.width - 12)),
                top: Math.min(Math.max(12, this.digitalHumanDragStart.top + e.clientY - this.digitalHumanDragStart.mouseY), Math.max(12, window.innerHeight - size.height - 12))
            }
        },
        stopDigitalHumanDrag() {
            if (!this.digitalHumanDragging) return
            this.digitalHumanDragging = false
            window.localStorage.setItem('digitalHumanPosition', JSON.stringify(this.digitalHumanPosition))
            document.removeEventListener('mousemove', this.onDigitalHumanDrag)
            document.removeEventListener('mouseup', this.stopDigitalHumanDrag)
        },
        // 企业合规官跳转
        toCCO() {
            window.open('https://ccoedu.org.cn/web.html', '_blank');
        },
        handleDocumentClick(e) {
          // 判断点击是否在输入框外
            // console.log(this.$refs.history);
            if (!this.$refs.autocomplete.contains(e.target) && !this.$refs.pop.contains(e.target)) {
              // console.log(111);
              if (this.seletShow != 0) {
                this.seletShow = 0
              }
              // 如果是，则不做任何处理，保持焦点
            } else {
                // console.log(222);
                // this.$refs.search.focus()
                // 如果不是，执行默认行为，如关闭输入法等
            }
        },

        // 新闻鼠标移入切换左边图片
        newsMouseTo(item, index) {
            // console.log(item);
            this.newActive = index
            this.checkImg = baseURL + item.coverImg
            this.checkTitle = item.title
        },

        // 企业资讯移入
        intervalMouseTo(item, index) {
            this.intervalActive = index
            this.checkImg = baseURL + item.coverImg
        },

        // 新闻、企业切换
        newtabClick(num) {
            this.newtab = num
            if (num == 1) {
                this.newActive = 0
                if (this.newsList.length > 0) {
                    this.checkImg = baseURL + this.newsList[0].coverImg
                }
            }
            // tab 2(企业资讯)和3(机构动态)不联动图片新闻
        },

        // 单独获取企业资讯列表(indexContent接口缺cate2)
        getQyzxList() {
            let _this = this
            api.getTree().then(res => {
                let { data } = res
                if (data.status == 200 && data.data) {
                    let cateId = ''
                    data.data.forEach(item => {
                        if (item.name == '企业资讯') {
                            cateId = item.id
                        }
                    })
                    if (cateId) {
                        api.getList({ cateId: cateId, title: '', page: 1, size: 8 }).then(res2 => {
                            let d = res2.data
                            if (d.status == 200 && d.data && d.data.data) {
                                _this.intervalList = d.data.data
                            }
                        })
                    }
                }
            })
        },

        // 获取首页数据
        getIndexInfo() {
            let _this = this
            api.getIndexInfo().then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.indexInfo = data.data
                    const articles = data.data.articles || {}
                    const initiativeArticles = this.getArticlesByCate(articles, ['诚信倡议单位', '诚信标杆企业'], [73]).slice(0, 6)
                    const reportArticles = this.getArticlesByCate(articles, ['信用报告', '信用百强'], [74]).slice(0, 6)
                    const dynamicArticles = this.getArticlesByCate(articles, ['机构动态'], [75]).slice(0, 8)
                    if (data.data.articles.cate1) {
                        this.checkImg = baseURL + data.data.articles.cate1[0].coverImg
                        this.checkTitle = data.data.articles.cate1[0].title
                    }
                    // articles


                    if (data.data.articles) {
                        if (data.data.articles.cate1) {
                            _this.newsList = data.data.articles.cate1.splice(0, 8)
                        }
                        if (data.data.articles.cate2) {
                            _this.intervalList = data.data.articles.cate2.splice(0, 8)
                        }    
                        if (dynamicArticles.length) {
                            _this.dynamicList = dynamicArticles
                        }
                        if (data.data.articles.cate3) {
                            _this.activityList = data.data.articles.cate3.splice(0, 6)
                        } 
                        if (data.data.articles.cate6) {
                            _this.caseList = data.data.articles.cate6.splice(0, 6)
                        }   
                        if (data.data.articles.cate7) {
                            _this.standardList = data.data.articles.cate7.splice(0, 6)
                        }    
                        if (reportArticles.length) {
                            _this.topHundredList = reportArticles
                        }
                        if (data.data.articles.cate9) {
                            _this.policyList = data.data.articles.cate9.splice(0, 6)
                        }    
                        if (data.data.articles.cate11) {
                            _this.studyList = data.data.articles.cate11.splice(0, 6)
                        }    
                        if (data.data.articles.cate12) {
                            _this.managementList = data.data.articles.cate12.splice(0, 6)
                        }    
                        if (data.data.articles.cate13) {
                            _this.exponentList = data.data.articles.cate13.splice(0, 6)
                        }    
                    }
                    
                    this.swiperNew = setInterval(() => {
                        if (this.newActive > _this.newsList.length-2) {
                            this.newActive = 0
                        } else {
                            this.newActive++
                            // console.log(this.newActive);
                        }

                        this.newsMouseTo(_this.newsList[this.newActive], this.newActive)
                    }, 5000)

                    if (data.data.companyRating) {
                        _this.evaluateCompanyList = data.data.companyRating.splice(0, 6)
                    }

                    if (data.data.companies.starCompany) {
                        _this.starLevelList = data.data.companies.starCompany.slice(0,6)
                    }
                    // if (data.data.companies.starCompany.length > 4) {

                    // } else {
                        // _this.starLevelList = data.data.companies.starCompany
                    // }
                    if (initiativeArticles.length) {
                        _this.sightcingList = initiativeArticles
                    }

                    if (data.data.persons.experts) {
                        _this.expertList = data.data.persons.experts.splice(0, 6)
                    }

                    if (data.data.persons.entrepreneur) {
                        _this.entrepreneurtList = data.data.persons.entrepreneur.splice(0, 6)
                    }

                    if (data.data.websiteLink) {
                        // console.log(data.data.websiteLink[1]);
                        if (data.data.websiteLink[1]) {
                            _this.friendLinkList = data.data.websiteLink[1]
                        }
                        if (data.data.websiteLink[2]) {
                            _this.friendLinkList2 = data.data.websiteLink[2]
                        }
                        if (data.data.websiteLink[3]) {
                            _this.friendLinkList2 = data.data.websiteLink[3]
                        }
                        if (data.data.websiteLink[4]) {
                            _this.friendLinkList4 = data.data.websiteLink[4]
                        }

                        if (data.data.websiteLink[5]) {
                            _this.advertisingList[0].href = data.data.websiteLink[5][0].linkUrl
                        }
                        if (data.data.websiteLink[6]) {
                            _this.advertisingList[1].href = data.data.websiteLink[6][0].linkUrl
                        }
                        if (data.data.websiteLink[7]) {
                            _this.advertisingList3[1].href = data.data.websiteLink[7][0].linkUrl
                        }

                        if (data.data.websiteLink[13]) {
                            _this.advertisingList3[0].href = data.data.websiteLink[13][0].linkUrl
                        }
                        if (data.data.websiteLink[15]) {
                            _this.advertisingList3[2].href = data.data.websiteLink[15][0].linkUrl
                        }
                    }

                    this.getGoodStudents()
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        getArticlesByCate(articles, names, ids) {
            const targetNames = names.map(item => this.normalizeCateName(item))
            const targetIds = (ids || []).map(item => Number(item))
            let list = []
            Object.keys(articles || {}).forEach(key => {
                const cateList = articles[key]
                if (!Array.isArray(cateList) || cateList.length === 0) return
                const first = cateList[0] || {}
                const cateName = this.normalizeCateName(first.cateName || first.cate_name)
                const cateId = Number(first.cateId || first.cate_id || String(key).replace('cate', ''))
                if (targetNames.indexOf(cateName) > -1 || targetIds.indexOf(cateId) > -1) {
                    list = list.concat(cateList)
                }
            })
            return list
        },
        normalizeCateName(name) {
            return String(name || '').replace(/\s/g, '')
        },

        // 获取优秀学员（放置企业诚信官）
        getGoodStudents() {
            let _this = this
            let params = {
                param: '',
                page: 1,
                limit: 5,
            }
            api.getGoodStudents(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.CXTList2 = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 优秀学员头像错误
        CXTImgError(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../assets/img/index/certificate2.png');
            img.onerror = null; //控制不要一直跳动 
        },

        // 广告1跳转
        toJump(item) {
            // console.log(item);
            if (item.href != '') {
                if (item.type == 'out') {
                    // this.$router.push({
                    //     path: item.href
                    // })
                    window.open(item.href + '?token=eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJ6aG9uZ3FpeWFuIn0.ZqtMLptDaKaxcKboNl_to2n8xsePgt_BllnbyiY8B80', '_blank');
                } else {
                    // this.$router.push({
                    //     path: item.href,
                    //     query: {
                    //         documentTitle: item.title
                    //     }
                    // })
                    // let routeUrl = this.$router.resolve({
                    //   path: item.href
                    // });
                    // console.log(routeUrl);
                    window.open(item.href, '_blank');
                }
            }
        },

        // 新闻图点击
        imgToPublicList() {
            let routeUrl = this.$router.resolve({
              path: "/newsDetail"
            });
            let title = ''
            if (this.newtab == 1) {
                this.$router.push({
                    name: 'newsDetail',
                    query: {
                        documentTitle: '新闻详情'
                    }
                })
                // title = '新闻详情'
                // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
            } else {
                this.$router.push({
                    name: 'newsDetail',
                    query: {
                        documentTitle: '企业资讯详情'
                    }
                })
                // title = '企业资讯详情'
                // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
            }
        },

        // 前往公共列表
        toPublicList(num) {
            // let routeUrl = this.$router.resolve({
            //   path: "/publicList"
            // });
            let title = ''
            if (num == 1) {
                this.$router.push({
                    name: 'publicList',
                    query: {
                        documentTitle: '新闻中心'
                    }
                })
                // title = '新闻中心'
                // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
            } else if (num == 2) {
                this.$router.push({
                    name: 'publicList',
                    query: {
                        documentTitle: '企业资讯'
                    }
                })
                // title = '企业资讯'
                // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
            } else {
                this.$router.push({
                    name: 'publicList',
                    query: {
                        documentTitle: '机构动态'
                    }
                })
            }
        },

        // 前往公共列表2
        toPublicList2(title) {
            this.$router.push({
                name: 'publicList',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/publicList"
            // });
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 新闻中心 企业资讯 活动通知 政策法规 信用标准 信用案例 信用研究 信用管理 信用指数
        //  + '?id=' + item.personId + '&staffName=' + item.personName
        toDetail(item, title) {
            this.$router.push({
                name: 'newsDetail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/newsDetail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },

        // 星级诚信企业
        toStarLevel(item, title) {
            this.$router.push({
                name: 'starLevel',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/starLevel"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },
        // 星级诚信企业更多点击
        toStarLevelMore(title,) {
            this.$router.push({
                name: 'starLevelSearch',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/starLevelSearch"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },
        toInitiativeMore() {
            this.toPublicList2('诚信倡议单位')
        },
        toInitiativeDetail(item) {
            this.toDetail(item, '诚信倡议单位详情')
        },

        // 信用企业更多点击
        toEvaluateCompanyMore(title) {
            this.$router.push({
                name: 'evaluateCompanySearch',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/evaluateCompanySearch"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },
        // 信用企业点击
        toEvaluateCompany(title, item) {
            this.$router.push({
                name: 'evaluateCompany',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/evaluateCompany"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },
        // 信用企业查询
        searchCompany(title) {
            if (this.companyInput == '') {
                this.$message.error('请输入查询关键字');
            } else {
                this.$router.push({
                    name: 'evaluateCompanySearch',
                    query: {
                        documentTitle: title,
                        searchName: this.companyInput
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: "/evaluateCompanySearch"
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + title + '&searchName=' + this.companyInput, '_blank');
            }
        },

        // 信用评价更多点击
        toEvaluate(title) {
            this.$router.push({
                name: 'creditEvaluate',
                query: {
                    documentTitle: title,
                    active: 0
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/creditEvaluate"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&active=0', '_blank');
        },
        // 信用评价选项点击
        toEvaluateOne(item, index) {
            // console.log(item);
            this.$router.push({
                name: 'creditEvaluate',
                query: {
                    documentTitle: '信用评价',
                    activeItem: JSON.stringify(item),
                    active: index
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/creditEvaluate"
            // });
            // let title = '信用评价'
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&activeItem=' + JSON.stringify(item) + '&active=' + index, '_blank');
        },

        // 企业诚信官跳转
        toIntegrity(title) {
            this.$router.push({
                name: 'integrity',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 人物搜索跳转
        toPersonSearch(title) {
            this.$router.push({
                name: 'personSearch',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/personSearch"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 前往人物详情
        toPersonDetail(item, title) {
            this.$router.push({
                name: 'personDetail',
                query: {
                    documentTitle: title + '详情',
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/personDetail"
            // });
            // let text = title + '详情'
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + text + '&id=' + item.id, '_blank');
        },

        // 跳转优秀学员
        toGoodStudents(item, index) {
            this.$router.push({
                name: 'personDetail',
                query: {
                    documentTitle: '优秀学员',
                    activeItem: JSON.stringify(item),
                    active: index
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/goodStudents"
            // });
            // let title = '优秀学员'
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&activeItem=' + JSON.stringify(item) + '&active=' + index, '_blank');
        },


        // 星级诚信企业图片错误回调
        imgerrorfun(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../assets/img/index/company.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        // 人物头像图片错误
        personImgError(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../assets/img/index/person.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        // 新闻 资讯图片错误回调
        imgError(e) {
            var img = e.srcElement;
            // console.log(img);
            // img.src = require('../assets/img/index/news.webp');
            img.src = '';
            // img.onerror = null; //控制不要一直跳动 
        },

        // 时间过滤
        time(time) {
            return time.substring(5,10)
        },

        // 友情链接下拉框点击
        seletClick(num) {
            if (this.seletShow == num) {
                this.seletShow = 0
            } else {
                this.seletShow = num
            }
        },

        // 友情链接跳转
        toUrl(item) {
            // console.log(routeUrl);
            window.open(item.linkUrl, '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
    .index {
        position: relative;
        padding-bottom: 220px;
        .digitalHuman {
            position: fixed;
            right: 24px;
            bottom: 80px;
            width: 92px; /*no*/
            height: 115px; /*no*/
            z-index: 1000;
            user-select: none;
            overflow: hidden;
            border-radius: 6px;
            transition: width .3s ease, height .3s ease;
            .digitalHumanHandle {
                position: absolute;
                top: 4px; /*no*/
                right: 4px; /*no*/
                width: 20px; /*no*/
                height: 10px; /*no*/
                cursor: move;
                background: rgba(19, 74, 166, 0.64);
                border: 1px solid rgba(255, 255, 255, 0.72);
                border-radius: 10px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
                transition: background-color .2s ease, box-shadow .2s ease;
                z-index: 2;
            }
            .digitalHumanHandle::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                width: 10px; /*no*/
                height: 3px; /*no*/
                border-top: 1px solid rgba(255, 255, 255, 0.92);
                border-bottom: 1px solid rgba(255, 255, 255, 0.92);
                transform: translate(-50%, -50%);
                opacity: 1;
            }
            .digitalHuman:hover .digitalHumanHandle {
                background: rgba(19, 74, 166, 0.86);
                box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);
            }
            .digitalHumanFrame {
                display: block;
                width: 100%;
                height: 100%;
                border: 0;
                background: transparent;
                transform: scale(1.65);
                transform-origin: center center;
            }
            .digitalHumanFrame.dragging {
                pointer-events: none;
            }
        }
        @media only screen and (max-width: 1700px) {
            .digitalHuman {
                width: 72px; /*no*/
                height: 90px; /*no*/
            }
        }
        @media only screen and (max-width: 1279px) {
            .digitalHuman {
                display: none;
            }
        }
        .main {
            // width: 80%;
            // min-width: 1152px;
            padding: 15px 20px;
            margin: 0 auto;
            @media only screen and (min-width: 769px) {
                width: 1320px; /*no*/
            }
            .publicTop {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                padding: 6px 5px;
                // padding: 10px;
                // background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                .title {
                    color: #333;
                    font-size: 20px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    // border-left: 2px solid #172EC9;
                }
                .title::before {
                    content: '';
                    display: inline-block;
                    width: 3px;
                    height: 18px;
                    background-color: #172EC9;
                    margin-right: 8px;
                }
                .more {
                    font-size: 16px;
                    color: #666;
                    cursor: pointer;
                }
            }
            .publicTop::before {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 30%;
                height: 2px;
                background-color: #172EC9;
            }
            .publicTop::after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 70%;
                height: 1px;
                background-color: #ccc;
            }
            .line1 {
                display: flex;
                justify-content: space-between;
                .chunk {
                    width: 32.5%;
                }
                .left {
                    width: 54.5%;
                    display: flex;
                    position: relative;
                    .skeleton {
                        width: 100%;
                        height: 500px;
                        object-fit: contain;
                    }
                    img {
                        margin: 0;
                    }
                    .swiperImg {
                        width: 100%;
                        height: 500px;
                        object-fit: cover;
                        object-position: center;
                    }
                    .swiper {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        position: absolute;
                        bottom: 0;
                        padding: 10px 15px;
                        width: 100%;
                        background-color: rgba(0, 0, 0, .3);
                        .checkTitle {
                            color: #fff;
                            font-size: 18px;
                            width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        ul {
                            right: 200px;
                            display: flex;
                            li {
                                width: 8px;
                                height: 8px;
                                border-radius: 8px;
                                border: 1px solid #fff;
                                margin-left: 2px;
                            }
                            .dotActive {
                                background-color: #fff;
                            }
                        }
                    }
                }
                .right {
                    width: 44.5%;
                    background-color: #fff;
                    padding: 10px 20px;
                    .news {
                        // border: 1px solid #5797FF;
                        width: 100%;
                        // padding: 0 10px;
                        border-left: none;
                        .top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 12px 0 10px;
                            border-bottom: 1px solid #ccc;
                            .top_left {
                                display: flex;
                                align-items: center;
                                color: #666;
                                .new {
                                    position: relative;
                                    cursor: pointer;
                                    font-size: 20px;
                                    font-weight: 700;
                                    img {
                                        position: absolute;
                                        top: -5px;
                                        left: -5px;
                                    }
                                }
                                .interval {
                                    width: 3px;
                                    height: 18px;
                                    background-color: #172EC9;
                                    margin: 0 10px;
                                }
                                .active {
                                    color: #CC0000;
                                }
                                .message {
                                    cursor: pointer;
                                    font-size: 20px;
                                    font-weight: 700;
                                }
                            }
                            .more {
                                font-size: 16px;
                                color: #666;
                                cursor: pointer;
                            }
                        }
                    }
                    
                    .list {
                        ul {
                            margin-top: 8px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 10px 0;
                            width: 100%;
                            .point {
                                display: block;
                                width: 5px;
                                height: 5px;
                                border-radius: 8px;
                                background-color: #666;
                                margin-left: 5px;
                            }
                            .title {
                                margin-left: 10px;
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 80%;
                            }
                            .active {
                                color: #CC0000;
                                .point {
                                    background-color: #CC0000;
                                    // background: url('../assets/img/index/arrows1.png') no-repeat;
                                }
                            }
                        }
                        li:nth-of-type(n+2) {
                            border-top: 1px solid #F0F0F0;
                        }
                    }
                    /* .list {
                        ul {
                            margin-top: 3px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 7px 10px;
                            .point {
                                width: 12px;
                                height: 14px;
                                border-radius: 0;
                                background-color: none;
                                background: url('../assets/img/index/arrows2.png') no-repeat;
                            }
                            .title {
                                margin-left: 10px;
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 60%;
                            }
                            .title:hover {
                                color: #258AFF;
                            }
                        }
                    } */
                }
            }
            .line {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                .chunk {
                    width: 32%;
                    min-height: 249px;
                    font-size: 18px;
                    // border: 1px solid #5797FF;
                }
                .common {
                    .list {
                        ul {
                            margin-top: 5px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 7px 5px;
                            .left {
                                width: 80%;
                            }
                            .right {
                                width: 20%;
                                text-align: right;
                                white-space: nowrap;
                            }
                            .title {
                                // margin-left: 10px;
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                // width: 280px;
                            }
                            .title::before {
                                content: '';
                                display: inline-block;
                                width: 5px;
                                height: 5px;
                                border-radius: 5px;
                                background-color: #666;
                                vertical-align: middle;
                                margin-right: 10px;
                            }
                            .title:hover {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .chunk2 {
                    width: 480px;
                    height: 295px;
                    border: 1px solid #5797FF;
                }
                .search {
                    width: 32%;
                }
                .advertising {
                    width: 24.5%;
                    img {
                        width: 100%;
                        height: 48%;
                        cursor: pointer;
                        object-fit: contain;
                        background-color: #F6F8FB;
                    }
                    img:nth-of-type(n+2) {
                        margin-top: 10px;
                    }
                }
                .advertising2 {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    img {
                        width: 32%;
                        height: 200px;
                        object-fit: contain;
                        background-color: #F6F8FB;
                    }
                    img:nth-of-type(n+2) {
                        margin-left: 15px;
                    }
                }
                .advertising3 {
                    width: 24.5%;
                    img {
                        width: 100%;
                        height: 21%;
                        cursor: pointer;
                    }
                    img:nth-of-type(n+2) {
                        margin-top: 14px;
                    }
                }
                .four:nth-of-type(n+2) {
                    margin-left: 15px;
                }
                .style1 {
                    .list {
                        ul {
                            margin-top: 3px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 7px 10px;
                            .point {
                                width: 12px;
                                height: 14px;
                                border-radius: 0;
                                background-color: none;
                                background: url('../assets/img/index/arrows2.png') no-repeat;
                            }
                            .title {
                                margin-left: 10px;
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 280px;
                            }
                            .title:hover {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .credit {
                    .list {
                        ul {
                            margin-top: 3px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            // padding: 7px 20px;
                            .point {
                                width: 13px;
                                height: 20px;
                                border-radius: 0;
                                background-color: none;
                                background: url('../assets/img/index/arrows3.png') no-repeat;
                            }
                            .title {
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                // width: 280px;
                                color: #258AFF;
                            }
                        }
                    }
                }
                .evaluateCompany {
                    .list {
                        ul {
                            margin-top: 5px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 7px 0;
                            .title {
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 70%;
                            }
                            .title::before {
                                content: '';
                                display: inline-block;
                                width: 5px;
                                height: 5px;
                                border-radius: 5px;
                                background-color: #666;
                                vertical-align: middle;
                                margin-right: 10px;
                            }
                            .title:hover {
                                color: #258AFF;
                            }
                            .rank {
                                font-size: 18px;
                                color: #666;
                                text-align: right;
                                width: 30%;
                            }
                        }
                    }
                }
                .starLevel {
                    .list {
                        ul {
                            padding: 20px 5px 0;
                            overflow: hidden;
                        }
                        li {
                            float: left;
                            width: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: top;
                            font-size: 16px;
                            color: #666;
                            // padding: 0 15px 25px 0;
                            cursor: pointer;
                            img {
                                width: 75px;
                                height: 75px;
                                object-fit: contain;
                                background-color: #F6F8FB;
                            }
                            .title {
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                word-break: break-all;
                                width: 100px;
                                margin-left: 10px;
                            }
                        }
                        li:nth-child(odd) {
                            padding: 0 15px 25px 0;
                        }
                        li:hover {
                            .title {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .sightcing {
                    .list {
                        // padding: 0 10px;
                        ul {
                            margin-top: 8px;
                        }
                        li {
                            display: flex;
                            justify-content: space-between;
                            padding: 10px 0;
                            .point {
                                display: block;
                                width: 5px;
                                height: 5px;
                                border-radius: 5px;
                                background-color: #666;
                                margin-left: 5px;
                            }
                            .title {
                                margin-left: 10px;
                                overflow: hidden;
                                cursor: pointer;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                // width: 280px;
                            }
                            .title:hover {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .expert {
                    .list {
                        ul {
                            padding: 12px;
                            overflow: hidden;
                        }
                        li {
                            float: left;
                            width: 50%;
                            display: flex;
                            justify-content: left;
                            align-items: top;
                            font-size: 16px;
                            cursor: pointer;
                            img {
                                width: 90px;
                                height: 67px;
                                object-fit: contain;
                                background-color: #F6F8FB;
                            }
                            .title {
                                font-size: 18px;
                                color: #333;
                            }
                            .profession {
                                color: #999;
                            }
                        }
                        li:nth-child(odd) {
                            padding: 0 15px 10px 0;
                        }
                        li::after {
                            content: "";
                            display: table;
                            clear: both;
                        }
                        li:hover {
                            .title {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .CXT {
                    .content {
                        .list {
                            padding: 15px;
                            li {
                                display: flex;
                                justify-content: space-between;
                                cursor: pointer;
                                .title {
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    width: 361px;
                                    color: #666;
                                    i {
                                        color: #134AA6;
                                    }
                                }
                                .profession {
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    width: 361px;
                                    color: #666;
                                    i {
                                        color: #134AA6;
                                    }
                                }
                            }
                            li:nth-of-type(n+2) {
                                margin-top: 25px;
                            }
                        }
                        // display: flex;
                        // justify-content: space-between;
                        // padding: 15px;
                        // .left {
                        //     padding: 10px 0;
                        //     text-align: center;
                        //     /deep/ .el-button {
                        //         background: #1A68E8;
                        //         font-size: 16px;
                        //         padding: 10px 15px;
                        //         border-radius: 1px;
                        //         margin-top: 30px;
                        //     }
                        // }
                        // .right {
                        //     margin-left: 15px;
                        //     font-size: 14px;
                        //     margin-top: 15px;
                        //     .CXTline {
                        //         padding-bottom: 5px;
                        //         overflow: hidden;
                        //         white-space: nowrap;
                        //         text-overflow: ellipsis;
                        //         width: 245px;
                        //         color: #666;
                        //         i {
                        //             color: #134AA6;
                        //             white-space: nowrap;
                        //             margin-right: 10px;
                        //         }
                        //     }
                        //     .task {
                        //         display: flex;
                        //         justify-content: left;
                        //         align-items: flex-start;
                        //         li {
                        //             margin-left: 10px;
                        //             color: #666;
                        //         }
                        //         li:nth-of-type(n+2) {
                        //             margin-top: 10px;
                        //         }
                        //     }
                        // }
                    }
                }
                .entrepreneurt {
                    .list {
                        ul {
                            overflow: hidden;
                            padding: 20px 5px 0;
                        }
                        li {
                            float: left;
                            width: 50%;
                            display: flex;
                            justify-content: left;
                            align-items: top;
                            font-size: 16px;
                            // padding: 0 15px 8px 0;
                            cursor: pointer;
                            img {
                                width: 75px;
                                height: 75px;
                                object-fit: contain;
                                background-color: #F6F8FB;
                            }
                            .title {
                                font-size: 18px;
                                color: #333;
                            }
                            .profession {
                                color: #999;
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                word-break: break-all;
                            }
                        }
                        li:nth-child(odd) {
                            padding: 0 15px 10px 0;
                        }
                        li:hover {
                            .title {
                                color: #258AFF;
                            }
                        }
                    }
                }
                .search {
                    width: 24.5%;
                    min-height: 249px;
                    font-size: 18px;
                    .top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        /deep/ .el-input {
                            margin-right: 15px;
                        }
                        /deep/ .el-input__inner {
                            border: 1px solid #1A68E8;
                            border-radius: 1px;
                        }
                        /deep/ .el-button {
                            padding: 12px 32px;
                            border: 1px  solid #1A68E8;
                            background-color: #1A68E8;
                            color: #fff;
                            border-radius: 1px;
                        }
                    }
                }
            }
            .line3 {
                margin-top: 10px;
            }
        }
        .friendLink {
            width: calc(100% - 10px);
            background-color: #fff;
            margin: 0 auto;
            margin-top: 15px;
            .content {
                width: 1300px;
                margin: 0 auto;
                padding: 15px;
                @media only screen and (max-width: 768px) {
                    width: 100%;
                }
                .from {
                    display: flex;
                    align-items: center;
                    position: relative;
                    .title {
                        font-size: 20px;
                        white-space: nowrap;
                        font-weight: 700;
                    }
                    .selet {
                        border: 1px solid #ddd;
                        border-radius: 3px;
                        padding: 5px 15px;
                        cursor: pointer;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 18px;
                        white-space: nowrap;
                        .icon {
                            margin-left: 65px;
                            color: #ccc;
                        }
                    }
                    .pop {
                        position: absolute;
                        bottom: 50px;
                        left: 0;
                        width: 1440px;
                        @media only screen and (max-width: 768px) {
                            width: 100vw;
                        }
                        min-height: 400px;
                        box-shadow: 0 10px 10px rgba(26,82,133,0.10);
                        padding: 20px 0 10px 20px;
                        background-color: #fff;
                        border-top: 3px solid #0449AE;
                        /deep/ .el-descriptions {
                            font-size: 16px;
                        }
                        /deep/ .el-descriptions-item__label:not(.is-bordered-label) {
                            display: none
                        }
                        /deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
                            padding-left: 20px;
                            white-space: nowrap;
                            cursor: pointer;
                        }
                    }
                }
                img {
                    width: 100%;
                    cursor: pointer;
                }
            }
        }
    }
</style>
